import React from 'react'
import { useODSData } from '../../hooks/ods-data-hook'
import { useSavedAdvertsContext } from '../../hooks/save-advert/saved-adverts-hook'
import { SaveAdvertButton } from './components/action-save-button'
import { SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing_trackingContext_TrackingContext } from '../../contexts/search-results-context/query/__generated__/search-results-listings.fed.query'

export interface SaveAdvertProps {
    advertId: string
    isSaved?: boolean
    sellerId?: string | null
    trackingContext?: SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing_trackingContext_TrackingContext
}

export const SaveAdvert = ({ advertId, trackingContext, isSaved = false }: SaveAdvertProps) => {
    const { loading, updateAdvertConnected } = useSavedAdvertsContext(trackingContext?.advertContext)
    const odsData = useODSData({ advertId, retailerId: trackingContext?.retailerContext?.id })
    const updateAdvert = () => updateAdvertConnected(!isSaved, advertId, odsData)

    return (
        <SaveAdvertButton
            saved={isSaved}
            onClick={() => updateAdvert()}
            loading={loading}
            testId={'save-advert-button-logged-in'}
        />
    )
}
